module.exports = __webpack_public_path__ + "static/media/2.40d7ecc5.jpg";